import { InsightsType } from "./insightTypes";

export const insightsReducer = {
  resetInsightsFetching: (state: InsightsType) => {
    state.fetching = false;
  },
  resetError: (state: InsightsType) => {
    state.error = null;
  },
  resetSuccess: (state: InsightsType) => {
    state.success = null;
  },
  resetInvoicingRevenueInsightsData: (state: InsightsType) => {
    state.invoicingRevenueInsightsData = [];
  },
  resetInvoicingExpensesInsightsData: (state: InsightsType) => {
    state.invoicingExpensesInsightsData = [];
  }
}